import Table from "react-bootstrap/Table";

import classes from "./CodesMovements.module.scss";

import { formatMilesDecimalNew } from "@/services/Utils";

const Codes = ({ data }) => {
	return (
		<Table striped hover size="sm">
			<thead>
				<tr>
					<th className={classes.tableTh}>Razón Social</th>
					<th className={classes.tableTh}>Campo</th>
					<th className={classes.tableTh}>Bodega</th>
					<th className={classes.tableTh}>Código</th>
					<th className={classes.tableTh}>Producto</th>
					<th className={classes.tableTh}>Proveedor</th>
					<th className={classes.tableTh}>Factura</th>
					<th className={classes.tableTh}>Guía de Despacho</th>
					<th className={classes.tableTh}>Cont. Compra</th>
					<th className={classes.tableTh}>Stock</th>
				</tr>
			</thead>
			<tbody>
				{data?.inventories.map((inventory, index) => {
					return (
						<tr key={index}>
							<td className={classes.tableTd}>{inventory.RAZON_SOCIAL}</td>
							<td className={classes.tableTd}>{inventory.GRUPOS_CAMPOS}</td>
							<td className={classes.tableTd}>{inventory.CAMPOS}</td>
							<td className={classes.tableTd}>
								<strong> {inventory.IDENTIFICADOR} </strong>
							</td>
							<td className={classes.tableTd}>{inventory.NOMBRE_COMERCIAL}</td>
							<td className={classes.tableTd}>{inventory.PROVEEDOR}</td>
							<td className={classes.tableTd}>{inventory.NUMERO_FACTURA}</td>
							<td className={classes.tableTd}>{inventory.NUMERO_GUIA_DE_DESPACHO}</td>
							<td className={`${classes.tableTd} ${classes.number}`}>
								{`${formatMilesDecimalNew(inventory.PRESENTACION_ENVASE)} `}
								{inventory.UNIDAD_DE_MEDIDA}
							</td>
							<td className={`${classes.tableTd} ${classes.number}`}>
								{`${formatMilesDecimalNew(inventory.STOCK)} `}
								{inventory.UNIDAD_DE_MEDIDA}
							</td>
						</tr>
					);
				})}
			</tbody>
		</Table>
	);
};

export default Codes;
